// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectOptions {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/app/Views/Security/RegisterDevice.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AADF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.selectOptions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
